import React from 'react';
import type { AddEmergencyConfigRequest } from '@/../generated-client/models';
import { EmergencyConfigModalBase } from './EmergencyConfigModalBase';
import { createDefaultEmergencyConfig } from './utils/defaultEmergencyConfig';

interface Props {
  show: boolean;
  onHide: () => void;
  onCreate: (config: AddEmergencyConfigRequest) => void;
  locked?: boolean;
}

export const CreateEmergencyConfigModal: React.FC<Props> = ({ show, onHide, onCreate, locked }) => {
  const defaultConfig = createDefaultEmergencyConfig();
  return (
    <EmergencyConfigModalBase
      show={show}
      onHide={onHide}
      config={defaultConfig}
      onSave={onCreate}
      mode="create"
      locked={locked}
    />
  );
};
